export default "__VITE_ASSET__CitiloFp__"